// extracted by mini-css-extract-plugin
export default {"see-more":"List_see-more__Ddv-F","time":"List_time__rt9h1","loader":"List_loader__vxMkJ","blank-filler":"List_blank-filler__Nt+0J"};